export default __webpack_public_path__ + "static/media/zombieclose.cf9cbd8f.mp3";